import type { JsonSchema, SchemaFormValue } from '@southfields-digital/mpxlive-components';

import { RuntimeFieldsForm } from '../RuntimeFields';

import styles from './DataConnectorPanel.module.scss';

type RuntimeFieldsSectionProps = {
  schema: JsonSchema;
  formData: SchemaFormValue | undefined;
  designTimeContext: SchemaFormValue;
  runtimeContext: SchemaFormValue;
  onContextChange: (values: SchemaFormValue) => void;
  isDisabled: boolean;
};

export const RuntimeFieldsSection = ({
  schema,
  formData,
  designTimeContext,
  runtimeContext,
  onContextChange,
  isDisabled,
}: RuntimeFieldsSectionProps) => {
  const hasProperties =
    schema.properties !== undefined && Object.keys(schema.properties).length > 0;

  if (!hasProperties) {
    return null;
  }

  const initialValues = {
    ...designTimeContext,
    ...formData,
    ...runtimeContext,
  };

  return (
    <div className={styles.FieldsSection}>
      <RuntimeFieldsForm
        schema={schema}
        initialValues={initialValues}
        designTimeContext={designTimeContext}
        onChange={onContextChange}
        isDisabled={isDisabled}
      />
    </div>
  );
};
